module.exports = __webpack_public_path__ + "img/FGT_Logo_Horizontal_NoTagline_White.6b724bbe.png";